const module = { name: 'movie/shared/calendarUI', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_util as Fandango_util_formatDate_toDate_weekDayMMMDD } from 'require-global';

const { formatDate, toDate, weekDayMMMDD } = Fandango_util_formatDate_toDate_weekDayMMMDD;


import { Fandango_dateUtil as Fandango_dateUtil_formatDateObject_whatsThisDateToMe } from 'require-global';

const { formatDateObject, whatsThisDateToMe } = Fandango_dateUtil_formatDateObject_whatsThisDateToMe;


import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as bannerMPS } from 'swug-fdRequire-call:movie/shared/bannerMPS';



import { default as datePicker } from 'swug-fdRequire-call:movie/shared/datePicker';



import { default as showtimesUI } from 'swug-fdRequire-call:movie/shared/showtimesUI';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as link } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



const DataAttribs = Object.freeze({
    DATE: 'data-show-time-date',
    DISABLED: 'data-disabled'
})


const Selectors = Object.freeze({
    CONTAINER: '#lazyload-movie-date-picker',
    DATE_BTN: `[${DataAttribs.DATE}]:not([${DataAttribs.DISABLED}="true"])`,
    FAN_ALERT_FORM: '#fanalert-form',
    FAN_ALERT_SECTION: '#new-fan-alert',
    FUTURE_DATE_NOTICE: '#future-date-notice',
    PLACEHOLDER: 'calendar-placeholder',
    SELECTED_DATE: '#mop-selected-date',
    CAROUSEL: 'date-carousel',
    MOVIE_TIMES: '#lazyload-movie-times',
    FORMATS: '#lazyload-format-filters',
    MOP_MERCH_CARD: '.js-merch-card',
    MOP_MERCH_CARD_MODAL_BTN: '.js-merch-card-modal-btn',
    MOP_MERCH_CARD_POPUP_MID: '#bundle-merch-card-popup-mid',
    MOP_MERCH_CARD_POPUP_TOP: '#bundle-merch-card-popup-top',
    MOP_RELEASE_DATE: '#movie-detail-release-date',
    TOP_BUNDLE: '#top-bundle-placeholder',
    MID_BUNDLE: '#mid-bundle-placeholder'
})


const Styles = Object.freeze({
    HIDE: 'hide'
})


const Markup = Object.freeze({
    PLACEHOLDER: '<div class="icon calendar-placeholder calendar-placeholder--mobile">Loading calendar&hellip;</div>',
})


const { isDesktop } = readPageContext(context)


const dependencies = {}


let onNotifyDateChange = noop()
function readPageContext(context) {
    const { device } = context || {};
    return {
        isDesktop: !device.isMobile,
    };
}
function showBusy() {
    $(Selectors.FAN_ALERT_SECTION).addClass(Styles.HIDE);
    $(Selectors.FUTURE_DATE_NOTICE).addClass(Styles.HIDE);
    debugLog.info(module.name, 'busy');
}
function renderFutureDateNotice(data) {
    const startDate = toDate(data.startDate);
    const params = new URLSearchParams(window.location.search);
    const queryParams = {
        date: formatDate(startDate)
    };
    if (params) {
        params.forEach((value, key) => {
            if (key === 'date') {
                return;
            }
            queryParams[key] = value;
        });
    }
    const viewModel = {
        isDesktop,
        isTomorrow: !!data.isTomorrow,
        startDate,
        url: link.mop({
            title: data.sluggedTitle,
            id: data.id
        }, queryParams)
    };
    const markup = swig.render('_datePickerFutureDateCta', viewModel);
    $(Selectors.FUTURE_DATE_NOTICE).remove();
    if (isDesktop) {
        $(Selectors.MOVIE_TIMES).before(markup);
    }
    else {
        $(Selectors.CONTAINER).after(markup);
    }
}
function onDateClick() {
    const selectedDate = `${this.dataset.showTimeDate}`.trim();
    if (!selectedDate) {
        return;
    }
    $(Selectors.FUTURE_DATE_NOTICE).addClass(Styles.HIDE);
    $(Selectors.TOP_BUNDLE).remove();
    $(Selectors.MID_BUNDLE).remove();
    historyStates.push(historyStates.HistoryEventTypes.CALENDAR, selectedDate);
    onNotifyDateChange(selectedDate);
    track({
        event: EventTypes.DATE_SELECTED,
        dateSelected: `${selectedDate} 00:00:00`,
    });
}
function onCalendarDone(data, movie, movieState, movieAttribs, extraOpts) {
    if (!data) {
        return;
    }
    const { sluggedTitle, id, releaseDateQueryParam, isReleaseInFuture } = movie;
    const { isOpensTomorrow: isTomorrow } = movieState;
    const { showTicketingPresale, startDate } = movieAttribs;
    const { initialRequestDate } = extraOpts || {};
    const { inFuture = false } = initialRequestDate ? whatsThisDateToMe(startDate, initialRequestDate.full) : {};
    const showFanAlert = Boolean(isReleaseInFuture && !data.hasCalendar);
    if (showFanAlert) {
        $(Selectors.FAN_ALERT_FORM).removeClass(Styles.HIDE);
    }
    if (showTicketingPresale) {
        $(Selectors.FAN_ALERT_FORM).addClass(Styles.HIDE);
        renderFutureDateNotice({
            sluggedTitle,
            id,
            startDate: startDate || releaseDateQueryParam,
            isTomorrow
        });
        showtimesUI.renderMopBundle();
    }
    if (showTicketingPresale || showFanAlert) {
        bannerMPS.topBannerExists(false, (hasBanner) => {
            if (hasBanner) {
                bannerMPS.removeBannerTopAd();
            }
        });
        bannerMPS.insertBannerTopAd({
            hasShowtimes: false,
            selector: showTicketingPresale ? Selectors.FUTURE_DATE_NOTICE : Selectors.FAN_ALERT_FORM
        });
        bannerMPS.displayBannerTopAd();
    }
    if (!data.hasCalendar) {
        return hideCalendar();
    }
    $(Selectors.MOP_RELEASE_DATE).toggleClass(Styles.HIDE, !showTicketingPresale && !inFuture);
    Object.assign(data, {
        inFuture,
        initialRequestDate: initialRequestDate || formatDateObject(toDate()),
        showTicketingPresale,
    });
    const template = isDesktop ? '_dateCarousel' : '_datePicker';
    const markup = swig.render(template, { data });
    const container = document.querySelector(Selectors.CONTAINER);
    container.innerHTML = markup;
    container.classList.remove(Styles.HIDE);
    document.getElementById(Selectors.PLACEHOLDER)?.remove();
    if (isDesktop) {
        const startIndex = !showTicketingPresale && data?.movieCalendar.calendar.findIndex(date => date.full === data.selectedDate);
        fdCarousel.init(Selectors.CAROUSEL, {
            autoWidth: true,
            padding: { left: 0, right: 0 },
            gap: 8,
            start: startIndex || 0
        });
        document.getElementById(Selectors.CAROUSEL)?.classList.remove(Styles.HIDE);
    }
    container
        .querySelectorAll(Selectors.DATE_BTN)
        .forEach(date => date.addEventListener('click', onDateClick));
    const selectedDate = data.selectedDate === formatDate(new Date()) ? 'Today\'s date' : weekDayMMMDD(data.selectedDate);
    $(Selectors.SELECTED_DATE).text(selectedDate);
    datePicker.highlightDate(container.id, data.selectedDate);
    datePicker.markToday(container.id);
    $(Selectors.FAN_ALERT_FORM).addClass(Styles.HIDE);
}
function showPlaceholder() {
    const $container = $(Selectors.CONTAINER);
    const placeholder = document.getElementById(Selectors.PLACEHOLDER);
    if (!placeholder) {
        $container.html(Markup.PLACEHOLDER);
    }
    $container.removeClass(Styles.HIDE);
}
function hideCalendar() {
    $(isDesktop ? `#${Selectors.CAROUSEL}` : Selectors.CONTAINER).addClass(Styles.HIDE);
}
module.exports = {
    addDependency(additions) {
        Object.assign(dependencies, additions);
    },
    busy: showBusy,
    done(data, movie, movieState, movieAttribs, opts) {
        onCalendarDone(data.calendar, movie, movieState, movieAttribs, opts);
    },
    error(data) {
        debugLog.error(`${module.name}.error`, data);
    },
    hide: hideCalendar,
    setOnDateChange(cb) {
        onNotifyDateChange = noop(cb);
    },
    showPlaceholder
};
export default module.exports;